import request from 'local_modules/request'
import { constants } from 'helpers'
import { reducers, getState } from 'redux/core'
import moment from 'moment'


const setFetching = (isFetching) => reducers.marketplace.adminSchedulePage.setFetching(isFetching)

const fetchSchedule = ({ year, month }) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.generateSchedule + `/${year}/${month}/${tool}`)
    .then(({ data }) => data)
    .then((data) => data.map(({ day, sessions }) => ({
      day: moment(day, 'YYYY-MM-DD').format('DD.MM.YYYY'),
      sessions,
    })))
    .then((data) => reducers.marketplace.adminSchedulePage.updateExistedSchedule({ data, year, month }))
    .catch((error) => console.log(error))
}

const updatedExistedSchedule = ({ day: updatedDay }) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  const year  = moment(updatedDay, 'DD.MM.YYYY').format('YYYY')
  const month = moment(updatedDay, 'DD.MM.YYYY').format('MM')

  return request.get(constants.marketplace.generateSchedule + `/${year}/${month}/${tool}`)
    .then(({ data }) => data)
    .then((data) => data.map(({ day, sessions }) => ({
      day: moment(day, 'YYYY-MM-DD').format('DD.MM.YYYY'),
      sessions,
    })))
    .then((data) => reducers.marketplace.adminSchedulePage.updateExistedSchedule({ data, year, month }))
    .catch((error) => console.log(error))
}

const setQuotaAndDescription = ({ scheduleId, quota, description }) => {
  return request.put(constants.marketplace.setQuotaAndDescription, { id: scheduleId, reserve: quota, description })
    .then(({ data }) => data)
    .catch((error) => console.log(error))
}

const resetSchedule = () => reducers.marketplace.adminSchedulePage.resetSchedule()

export default {
  setFetching,
  resetSchedule,

  updatedExistedSchedule,
  fetchSchedule,
  setQuotaAndDescription,
}
